<div class="arrowBtn d-none d-md-inline">
  <a (click)="goBack()" class="btn btn-outline-dark">
    <i class="bi bi-arrow-left arrowIcon"></i>
  </a>
</div>

<div *ngIf="(systemStatus == null || systemStatus!.id == 1 || systemStatus!.id == 3); else unauthorizedBlock"
  class="container" style="min-width: 350px;">
  <div class="row">
    <div class="col-12 p-2 text-center">
      <h2 class="inline-bordered">
        {{systemName}}
      </h2>
    </div>

    <div class="col-12 col-md-6 text-center mt-2">
      <span class="fst-italic">{{"SYSTEM.SYSTEMMANAGEMENT.MANDATORY" | translate}}<sup>*</sup></span>
    </div>

    <div *ngIf="idsystem > 0" class="col-12 col-md-6 text-center mt-2">
      <span class="fw-bold">
        {{"SYSTEM.SYSTEMMANAGEMENT.STATUS" | translate}}:
      </span>
      <span class="ms-1">
        <i class="bi bi-circle-fill" style="font-size: large;" [ngStyle]="{'color':  '#'+systemStatus?.color}">
        </i>
      </span>
      <span class="ms-1">
        {{systemStatus?.name}}
      </span>
    </div>

    <div class="col-12 p-0">
      <mat-stepper orientation="vertical" [linear]="true" #stepper>

        <mat-step [stepControl]="stepOneForm" errorMessage="Incomplete" [editable]="isEditable[0]">
          <ng-template matStepLabel>
            <span style="font-weight: bold;">{{"SYSTEM.SYSTEMMANAGEMENT.SYSANDCUSTINFO" | translate}}</span>
          </ng-template>
          <app-step-one #stepOne (idEmitter)="onIdReceived($event)" (formEmit)="onFormOneReceived($event)"
            (changeStep)="manageStepScrolling($event, stepper)" [idsystem]="idsystem">
          </app-step-one>
        </mat-step>

        <mat-step [stepControl]="stepTwoForm" errorMessage="Incomplete" [editable]="isEditable[1]">
          <ng-template matStepLabel><span style="font-weight: bold;">{{"SYSTEM.SYSTEMMANAGEMENT.INSTALLATIONSITE" |
              translate}}</span>
          </ng-template>
          <ng-template matStepContent>
            <app-step-two #stepTwo (formEmit)="onFormTwoReceived($event)" (changeStep)="manageStepScrolling($event, stepper)"
              [idsystem]="idsystem">
            </app-step-two>
          </ng-template>

        </mat-step>

        <mat-step [stepControl]="stepThreeForm" errorMessage="Incomplete" [editable]="isEditable[2]">
          <ng-template matStepLabel><span style="font-weight: bold;">{{"SYSTEM.SYSTEMMANAGEMENT.TECHNICIANINFO" |
              translate}}</span></ng-template>
          <ng-template matStepContent>
            <app-step-three #stepThree (formEmit)="onFormThreeReceived($event)" (changeStep)="manageStepScrolling($event, stepper)"
              [idsystem]="idsystem">
            </app-step-three>
          </ng-template>
        </mat-step>

        <mat-step [stepControl]="stepFourForm" errorMessage="Incomplete" [editable]="isEditable[3]">
          <ng-template matStepLabel><span style="font-weight: bold;">{{"SYSTEM.SYSTEMMANAGEMENT.DEVICESINFO" |
              translate}}</span></ng-template>
          <ng-template matStepContent>
            <app-step-four *ngIf="stepThreeForm.valid" #stepFour (formEmit)="onFormFourReceived($event)"
            (changeStep)="manageStepScrolling($event, stepper)" [idsystem]="idsystem">
            </app-step-four>
          </ng-template>
        </mat-step>

        <mat-step [stepControl]="stepFiveForm" errorMessage="Incomplete" [editable]="isEditable[4]">
          <ng-template matStepLabel><span style="font-weight: bold;">{{"SYSTEM.SYSTEMMANAGEMENT.INVERTER" |
              translate}}</span></ng-template>
          <ng-template matStepContent>
            <app-step-five *ngIf="stepFourForm.valid" #stepFive (formEmit)="onFormFiveReceived($event)"
            (changeStep)="manageStepScrolling($event, stepper)" [idsystem]="idsystem">
            </app-step-five>
          </ng-template>
        </mat-step>

        <mat-step *ngIf="stepFourService.product_systemcomposition === 3" [stepControl]="stepSixForm"
          errorMessage="Incomplete" [editable]="isEditable[5]">
          <ng-template matStepLabel><span style="font-weight: bold;">{{"SYSTEM.SYSTEMMANAGEMENT.BATTERIES" |
              translate}}</span></ng-template>
          <ng-template matStepContent>
            <app-step-six *ngIf="stepFiveForm.valid" #stepSix (formEmit)="onFormSixReceived($event)"
            (changeStep)="manageStepScrolling($event, stepper)" [idsystem]="idsystem">
            </app-step-six>
          </ng-template>
        </mat-step>

        <!-- <mat-step [stepControl]="stepFiveForm" errorMessage="Address is required.">
            <ng-template matStepLabel>ADDITIONAL INFO</ng-template>
            <app-step-five #stepFive [idsystem]="idsystem"></app-step-five>
          </mat-step> -->

        <mat-step>
          <ng-template matStepLabel>
            <span style="font-weight: bold;">{{"SYSTEM.SYSTEMMANAGEMENT.CONFIRMATION" | translate}}</span>
          </ng-template>
          <div class="col-12 text-center px-0 py-2">
            <button class="btn btn-outline-dark mb-2" (click)="readOnly()">
              {{"SYSTEM.SYSTEMMANAGEMENT.OVERVIEW" | translate}}
            </button>
          </div>
          <div class="text-center">
            <p>{{"SYSTEM.SYSTEMMANAGEMENT.REQUEST" | translate}}</p>
            <button *ngIf="stepFourService.product_systemcomposition === 3;" class="btn btn-outline-dark me-2" (click)="manageStepScrolling({step: 7, action: 0}, stepper)">{{"SYSTEM.STEPBUTTONS.PREV" |
              translate}}
            </button>
            <button *ngIf="stepFourService.product_systemcomposition != 3" class="btn btn-outline-dark me-2" (click)="manageStepScrolling({step: 6, action: 0}, stepper)">{{"SYSTEM.STEPBUTTONS.PREV" |
                translate}}
            </button>
            <!-- <button mat-button (click)="stepper.reset()">Reset</button> -->
            <button class="btn btn-outline-dark ms-2" (click)="approvalRequested()" [disabled]="!getAllFormValid()">
              {{"SYSTEM.STEPBUTTONS.SEND" | translate}}
            </button>
            <div class="mt-2 text-danger" style="font-size: small; font-weight: bold;" *ngIf="!getAllFormValid()">
              {{"SYSTEM.SYSTEMMANAGEMENT.COMPLETE" | translate}}
            </div>
          </div>
        </mat-step>
      </mat-stepper>
    </div>
  </div>
</div>

<ng-template #unauthorizedBlock>
  <div class="container mt-2 p-1 p-sm-2 p-md-3 p-lg-4" style="height: 80vh;">
    <div class="row justify-content-center align-items-center mt-5">
      <div class="col-12 p-2 text-center">
        <h2 class="inline-bordered">
          {{systemName}}
        </h2>
      </div>
      <div class="col-12 text-center mt-5">
        <span style="font-size: x-large;">
          {{"SYSTEM.SYSTEMMANAGEMENT.CANNOTMODIFY" | translate}}
        </span>
      </div>
      <div class="col-12 text-center mt-4">
        <button class="btn btn-outline-dark" (click)="goToSystem()">
          {{"SYSTEM.SYSTEMMANAGEMENT.OVERVIEW" | translate}}
        </button>
      </div>
    </div>
  </div>
</ng-template>